import { OrderSection, type OrderSectionProps } from './OrderSection';

export function RadiologyOrderSection(props: OrderSectionProps) {
  return <OrderSection kind="radiology" {...props} />;
}
